import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './utils/interceptors/jwt.interceptor';

const ArchOfTraitsPreset = definePreset(Aura, {
  components: {
    toggleswitch: {
      colorScheme: {
        light: {
          root: {
            checkedBackground: '#00c8e8',
            checkedHoverBackground: '#00b5d4',
            width: '3rem',
            height: '1.6rem',
          },
          handle: {
            checkedBackground: '#ffffff',
            size: '1.2rem',
          },
        },
        dark: {
          root: {
            checkedBackground: '#00c8e8',
            checkedHoverBackground: '#00b5d4',
            width: '3rem',
            height: '1.6rem',
          },
          handle: {
            checkedBackground: '#ffffff',
            size: '1.2rem',
          },
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    // withInterceptorsFromDi — required for class-based interceptors
    provideHttpClient(withInterceptorsFromDi()),
    // Register class-based interceptor via DI token
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    MessageService,
    DialogService,
    providePrimeNG({
      theme: {
        preset: ArchOfTraitsPreset,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-base, primeng, tailwind-utilities',
          },
        },
      },
      ripple: true,
    }),
  ],
};